import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {

  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENTS]: {
    url: '/company/:companyId/fuel_stations/events/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].PATCH_FUEL_STATION_EVENT]: {
    url: '/company/:companyId/fuel_stations/events/:fuelEventId/',
    requestOptions: {
      method: 'PATCH',
    },

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT]: {
    url: '/company/:companyId/fuel_stations/events/:fuelEventId/',

  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_POPUP]: {
    url: '/company/:companyId/fuel_stations/events/:fuelEventId/popup/',
  },
  [ModulesConfigMap[ModulesMap.FUEL_STATION_EVENTS].GET_FUEL_STATION_EVENT_PREVIEW]: {
    url: '/company/:companyId/fuel_stations/events/:fuelEventId/preview/',

  }
}